<template>
  <div class="history-page-wrapper">
    <div class="title-and-tools">
      <h2>Recent Edits</h2>
      <section>
        <div class="sub-content">
          <div class="item link">
            <cricket-match-mini :matchKey="'mumbait20_2019_g15'"></cricket-match-mini>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { DataState } from '@/state'
import { FantasyEditPoints } from '@/models/workflow/cricket/fantasy'

export default {
  name: 'RecentEditPage',
  data () {
    return {
      state: DataState.newLoading()
    }
  },
  mounted () {
    this.getRecentEdits ()
  },
  methods: {
    getRecentEdits () {
      FantasyEditPoints.fetchRecentEdits()
    }
  }
}
</script>
